<script>
import {
  pageInfosEtServicesProspectusProps,
  usePageInfosEtServicesProspectus
} from "./mixin";
import Divider from "@/components/atoms/divider";
import Prospectus from "@/components/molecules/prospectus";
import Button from "@/components/atoms/button";
import Icon from "@/components/atoms/icon";
import LazyImage from "@/components/atoms/lazy-image";
import Container from "@/components/atoms/container";
import footerCodes from "@/utils/footer-codes";
import Titre from "@/components/atoms/titre";

import messenger from "@/assets/images/mon-compte/icons/messenger.svg";
import whatapp from "@/assets/images/mon-compte/icons/whatapp.svg";
import { useContextStore } from "@/store/context";

export default {
  components: {
    Divider,
    Prospectus,
    Button,
    Icon,
    LazyImage,
    Container,
    Titre
  },
  props: {
    ...pageInfosEtServicesProspectusProps()
  },
  setup() {
    const { isNational, socialMediaLinkClicked } =
      usePageInfosEtServicesProspectus();
    return {
      isNational,
      socialMediaLinkClicked,
      messenger,
      whatapp
    };
  },
  data() {
    return {
      footerCodes
    };
  }
};
</script>

<template>
  <div>
    <div class="c-prospectus-list-header">
      <Container>
        <div class="c-prospectus-list-header__title-wrapper">
          <h1 class="c-prospectus-list-header__title">
            Prospectus
          </h1>
          <Divider
            dotted
            vertical
            size="sm"
            class="c-prospectus-list-header__divider-title"
          />

          <p class="c-prospectus-list-header__total">
            {{ prospectus.length }} prospectus à consulter
          </p>
        </div>
        <p class="c-prospectus-list-header__text">
          Commandez depuis vos prospectus en ligne. <br>
          Vous pouvez ajouter les produits du prospectus directement dans votre panier.
        </p>

      </Container>
    </div>
    <div
      v-if="prospectus.length > 0"
      class="c-prospectus-list__list-wrapper u-bgcolor-bg"
    >
      <div class="c-prospectus-list__list">
        <Prospectus
          v-for="item in prospectus"
          :key="item.id"
          img-width="300"
          :img-path="item.attributes.cover"
          :period="item.attributes.period"
          :title="item.attributes.title"
          :link="item.attributes.url"
          :can-add-to-cart="item.attributes.can_add_to_cart"
          :is-national="isNational"
          :start-date="item.attributes.start_at"
          :page-type="trackingCodes.PAGETYPE.prospectus"
        />
      </div>
    </div>
    <div
      v-else
      class="u-p-md"
    >
      <div class="u-p-md u-text-center">
        <Titre
          variant="primary"
          size="md"
          tag="h1"
          class="u-text-center u-mb-md"
        >
          Aucun prospectus n'est disponible pour le moment
        </Titre>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-prospectus-list-header {
  background-color: #fff;
  padding-bottom: spacing(lg);
}
.c-prospectus-list-header__title-wrapper {
  display: flex;
  display: inline-flex;
  align-items: baseline;
  column-gap: spacing(xs);
  margin-bottom: spacing(sm);
  margin-top: spacing(xs);

  @include mq(bp(sm)) {
    flex-direction: column;
  }
}
.c-prospectus-list-header__title {
  font-family: font(secondary);
  font-size: fontSize(28);
  font-weight: 700;
}
.c-prospectus-list-header__divider-title {
  @include mq(bp(sm)) {
    display: none;
  }
}
.c-prospectus-list-header__total {
  font-size: fontSize(18);
  font-weight: 500;
}
.c-prospectus-list-header__text {
  font-size: fontSize(14);
}

.c-prospectus-list-header__newsletter {
  display: flex;
  justify-content: space-between;
  border: 2px solid color(primary);
  padding: spacing(sm) spacing(lg) spacing(sm) 2rem;
  max-width: 92.8rem;
  width: 100%;
  border-radius: radius(md);
  margin-top: spacing(lg);
  @include mq(bp(md)) {
    padding: spacing(sm) spacing(md);
    flex-direction: column;
    align-items: center;
  }

  .c-prospectus-list-header__newsletter-content {
    display: flex;
    gap: spacing(md);
    @include mq(bp(md)) {
      flex-direction: column;
      align-items: center;
      margin-bottom: spacing(sm);
    }
  }

  .c-prospectus-list-header__newsletter-text {
    font-size: fontSize(14);
  }
  .c-prospectus-list-header__newsletter-button-wrapper {
    display: flex;
    gap: 1.2rem;
    @include mq(340px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}

.c-prospectus-list__list-wrapper {
  max-width: calc(131.2rem + 3.2rem);
  padding: 0 spacing(sm);
  margin: 0 auto;
  padding-top: spacing(sm);
  padding-bottom: 7rem;
}
.c-prospectus-list__list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(31.6rem, max-content));
  justify-content: center;
  gap: spacing(sm);
  @include mq(bp(md)) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
}
</style>
